import { Flex, Text } from "@chakra-ui/react";
import React from "react";
import {
  Clock,
  CornerDownRight,
  Facebook,
  Instagram,
  Linkedin,
  Mail,
  MapPin,
  Smartphone,
} from "react-feather";
import { GoogleMap, LoadScript } from "@react-google-maps/api";
import Card from "../Card";

interface footerProps {}
const Footer: React.FC<footerProps> = () => {
  return (
    <Flex bg="black" align="center" w="100%">
      <Flex w="100%" h="35rem">
        <Flex
          mt={10}
          p={50}
          w="35%"
          h="75%"
          direction="column"
          alignContent="left"
        >
          <Text fontSize="medium" fontWeight="bold" align="left" color="white">
            Get In Touch
          </Text>
          <br />
          <Text align="left" color="white">
            <MapPin />
            Constantia Square Office Park
            <br /> 526 16th Road, Midrand, Gauteng, 1685
            {/* <br />
            <br />
            <Smartphone />
            (071) 678 1609 */}
            <br />
            <br />
            <Mail /> admin@hrbee.co.za
            <br />
            <br />
            <Clock />
            Monday - Friday: 9am - 5pm Saturday, Sunday: Closed
            <br />
            <br />
            <br />
            <br />
            <Flex>
              <Linkedin size={30} enableBackground="white" />{" "}
              <Facebook size={30} enableBackground="white" />{" "}
              <Instagram size={30} enableBackground="white" />{" "}
            </Flex>
          </Text>
        </Flex>
        <Flex w="80rem" h="20rem" justify="space-around" p={35} mt={10}>
          <Flex w="15rem" direction="column">
            <Text
              fontSize="medium"
              fontWeight="bold"
              align="left"
              color="white"
            >
              Quick Links
            </Text>
            <br />
            <br />
            <Card color="white" w="25%">
              <CornerDownRight /> Home
            </Card>
            <br />
            <Card color="white" w="25%">
              <CornerDownRight /> About
            </Card>
            <br />
            <Card color="white" w="32%">
              <CornerDownRight /> Services
            </Card>
            <br />
            <Card color="white" w="41%">
              <CornerDownRight /> Documents
            </Card>
          </Flex>
          <Flex w="40rem" h="20rem">
            <LoadScript googleMapsApiKey="AIzaSyCKIE4mmvtP7pDvfsQnociz6eTkdlSJ-Cs">
              <GoogleMap
                mapContainerStyle={{
                  width: "100%",
                  height: "100%",
                }}
                center={{ lat: -25.975891448930753, lng: 28.13309006927586 }}
                zoom={15}
                options={{
                  scrollwheel: true,
                }}
              ></GoogleMap>
            </LoadScript>
          </Flex>
        </Flex>
      </Flex>
    </Flex>
  );
};

export default Footer;
